import OrganizationContainer from '@shared/hooks/state/OrganizationContainer';
import { useEffect, useMemo } from 'react';
import useResolveCurrentOrg from './useResolveCurrentOrg';

export function useCurrentOrgMemberFetching() {
    const { organizationId } = useResolveCurrentOrg();
    const {
        organizationMembers,
        organizationMembersRef,
        loadOrganizationMembers,
        loadingDataRef,
        loadingData,
        handleLoadingDataChange,
    } = OrganizationContainer.useContainer();

    const members = useMemo(() => {
        if (!organizationId) return null;
        return organizationMembersRef.current.find((org) => org.organizationId === organizationId)?.members ?? [];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId, organizationMembers]);

    useEffect(() => {
        async function fetchMembers() {
            if (!organizationId || loadingDataRef.current.organizationMembers == true) return;
            handleLoadingDataChange('organizationMembers', true);
            const org = organizationMembersRef.current.find((org) => org.organizationId === organizationId);
            if (org?.members && org.members.length > 0) {
                handleLoadingDataChange('organizationMembers', false);
                return;
            }

            try {
                const result = await loadOrganizationMembers(organizationId);
                if (result?.resultType !== 'Ok') {
                    console.error('Failed to load members for organization:', organizationId);
                }
            } catch (error) {
                console.error('Error loading members.');
            } finally {
                handleLoadingDataChange('organizationMembers', false);
            }
        }
        fetchMembers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organizationId]);

    return { members, isLoading: loadingData.organizationMembers };
}
